import dynamic from 'next/dynamic'
import { FC, useEffect, useRef, useState } from 'react'
import LazyLoad from 'react-lazyload'
import { ToastContainer } from 'react-toastify'
import FAQHH from './components/FAQ'
import SectionIntroduceHH from './components/Introduce'
import PartnerHH from './components/Partner'
import ProcessHH from './components/Process'
import SectionReasonHH from './components/Reason'
import SectionStrengthsDesktop from './components/Strengths/StrengthsDesktop'
import StrengthsMobile from './components/Strengths/StrengthsMobile'
import TeamMemberDesk from './components/TeamMember/TeamMemberDesk'
import TeamMemberMobile from './components/TeamMember/TeamMemberMobile'
import { isMobile } from 'react-device-detect'
import Strategic from './components/Strategic'

const ContactHHDesktop = dynamic(() => import('./components/Contact/ContactDesktop'))
const ContactHHMobile = dynamic(() => import('./components/Contact/ContactMobile'))
const MapHH = dynamic(() => import('./components/Map'))
const TestimonialsDesk = dynamic(() => import('./components/Testimonials/TestimonialsDesk'))

const LazyLoadCustom: FC<{ isLazyLoading; props }> = ({ isLazyLoading = true, props, children }) => {
  return isLazyLoading ? <LazyLoad {...props}>{children}</LazyLoad> : <div>{children}</div>
}

const BrowserView: FC = ({ children }) => {
  const [render, setRender] = useState(true)
  useEffect(() => {
    if (isMobile) {
      setRender(false)
    }
  }, [])
  return render ? <>{children}</> : <></>
}
const MobileView: FC = ({ children }) => {
  const [render, setRender] = useState(false)
  useEffect(() => {
    if (isMobile) {
      setRender(true)
    }
  }, [])
  return render ? <>{children}</> : <></>
}
const HeadhuntServiceWrapper: FC<{ setRef?; getRefPromise?; setRefMobile?; getRefPromiseMobile?; isLazyLoading?; setIsLazyLoading? }> = ({
  setRef,
  getRefPromise,
  setRefMobile,
  getRefPromiseMobile
}) => {
  const contactRef = useRef(null)
  const contactMobileRef = useRef(null)
  const [isLazyLoading, setIsLazyLoading] = useState(true)

  return (
    <>
      <style jsx>{`
        .headhunt {
          width: 100vw;
          overflow: hidden;
        }
      `}</style>
      <div className="headhunt">
        <SectionIntroduceHH getRef={getRefPromise} getRefMobile={getRefPromiseMobile} setIsLazyLoading={setIsLazyLoading} />
        <SectionReasonHH />
        <Strategic getRef={getRefPromise} getRefMobile={getRefPromiseMobile} setIsLazyLoading={setIsLazyLoading} />
        <TeamMemberDesk getRef={getRefPromise} getRefMobile={getRefPromiseMobile} setIsLazyLoading={setIsLazyLoading} />
        <ProcessHH getRef={getRefPromise} getRefMobile={getRefPromiseMobile} setIsLazyLoading={setIsLazyLoading} />

        <TestimonialsDesk />

        <PartnerHH getRef={getRefPromise} getRefMobile={getRefPromiseMobile} setIsLazyLoading={setIsLazyLoading} />

        {/* <FAQHH /> */}
        <ContactHHDesktop setRef={setRef} contactRef={contactRef} />
        {/* <BrowserView>
          <ContactHHDesktop setRef={setRef} contactRef={contactRef} />
        </BrowserView>
        <MobileView>
          <ContactHHMobile setRef={setRefMobile} contactRef={contactMobileRef} />
        </MobileView> */}
        {/* <MapHH /> */}
        <ToastContainer />
      </div>
    </>
  )
}

export default HeadhuntServiceWrapper
